import type { KnowledgeBaseDocument } from 'entities/KnowledgeBase/model/KnowledgeBaseDocument'

export const hasGoogleSheetLiveDocument = (documents: KnowledgeBaseDocument[]) =>
  documents.some((document) => document.getIsLiveDocument() && document.getIsGoogleSheet())

export const hasGoogleDocLiveDocument = (documents: KnowledgeBaseDocument[]) =>
  documents.some((document) => document.getIsLiveDocument() && document.getIsGoogleDoc())

export const hasAccessLostLiveDocument = (documents: KnowledgeBaseDocument[]) =>
  documents.some((document) => document.getIsAccessLost())
